import { render, staticRenderFns } from "./TXdeposit.vue?vue&type=template&id=1adb3782"
import script from "./TXdeposit.vue?vue&type=script&lang=js"
export * from "./TXdeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports